// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

window.Rails = require("@rails/ujs")

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Turbolinks.start()
ActiveStorage.start()

import "controllers"
Rails.start()

global.jQuery, global.$ = require("jquery");
require('datatables.net-bs4')

require("bootstrap")
import "zxing"

import "canvas-confetti"
const confetti = require('canvas-confetti');

import "../stylesheets/application";

import "@fortawesome/fontawesome-free/js/all";


require("packs/mynails_effects")
require("packs/password_show_hide.js")
require("packs/select_tombola_interest")
require("packs/select_service")
require("packs/new_appointment")
require("packs/service_appointment")
require("packs/qrcodetracker")
require("packs/select_beauty_id")

const initCollapseToggleButtons = () => {
    const $toggleButtons = $('[data-toggle="collapse"][data-toggle-text-collapsed]');
    $toggleButtons.each(function() {
        const $button = $(this);
        const collapsedText = $button.data('toggle-text-collapsed') || $.trim($button.text());
        const expandedText = $button.data('toggle-text-expanded') || collapsedText;
        const targetSelector = $button.attr('data-target') || $button.attr('href');
        const $collapse = targetSelector ? $(targetSelector) : $();

        const updateButtonLabel = (isExpanded) => {
            $button.text(isExpanded ? expandedText : collapsedText);
        };

        updateButtonLabel($button.attr('aria-expanded') === 'true');

        if ($collapse.length) {
            $collapse
                .off('shown.bs.collapse.toggleText hidden.bs.collapse.toggleText')
                .on('shown.bs.collapse.toggleText', () => updateButtonLabel(true))
                .on('hidden.bs.collapse.toggleText', () => updateButtonLabel(false));
        }

        $button
            .off('click.toggleText')
            .on('click.toggleText', function() {
                const willExpand = $(this).attr('aria-expanded') !== 'true';
                updateButtonLabel(willExpand);
            });
    });
};

window.initCollapseToggleButtons = initCollapseToggleButtons;

document.addEventListener("turbolinks:load", () => {  
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
            })(window,document,'script','//www.google-analytics.com/analytics.js','ga');
        ga('create', 'UA-70100779-1', 'auto');
        ga('require', 'linkid');
        ga('send', 'pageview');
        $('[data-toggle="tooltip"]').tooltip()
        $('[data-toggle="popover"]').popover()
        initCollapseToggleButtons()
    })


window.initToolTips = function() {
    $('[data-toggle="tooltip"]').tooltip({
        trigger: 'hover focus' // This will trigger tooltips on both hover and focus
    });
}
